import { Component, Input, OnInit } from '@angular/core';
import { Behavior } from 'popper.js';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AssetClassModel, ValuationModel } from 'src/app/core/asset_class';
import { AssignmentModel } from 'src/app/core/assignment';
import { ReportingProcessData } from 'src/app/core/reporting/_models/reporting_process.model';
import { ToeModel } from 'src/app/core/toe';
import { SupportingValuerModel } from 'src/app/core/toe/_models/supporting-valuer.model';
import { ValuationProcessService } from 'src/app/core/valuation-process';

@Component({
  selector: 'kt-valuation-info',
  templateUrl: './valuation-info.component.html',
  styleUrls: ['./valuation-info.component.scss']
})
export class ValuationInfoComponent implements OnInit {
  @Input() tp: AssetClassModel;
  @Input() toe: ToeModel;
  @Input() valuation: ValuationModel;
  @Input() workers: SupportingValuerModel[];
  @Input() assignment: AssignmentModel;
  @Input() reporting: ReportingProcessData;

  loading$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  drcData$: BehaviorSubject<any> = new BehaviorSubject(null)

  constructor(
    private valuationProcessService: ValuationProcessService
  ) { }

  ngOnInit(): void {
    this.loading$.next(false);

    this.valuationProcessService.summaryData(
      this.tp.id,
      this.valuation.id
    ).subscribe(
      res => {
        this.drcData$.next((res as any).summary)
      }
    )
  }

  showSummary(valuation: ValuationModel) {
    if (valuation.methods_to_value_id == 2) return 'market'
    if (valuation.approaches_to_value_id == 2 && ![9].includes(valuation.methods_to_value_id)) return 'income'
    if (valuation.methods_to_value_id == 10) return 'drc'
    return 'manual'
  }
}
